import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { getCityByCountry, getCountryList } from 'stores/globalAddressSlice';

import AppLogger from 'utils/AppLogger';

import useAlert from './useAlert';

const useAddressData = () => {
	// States
	const [countries, setCountries] = useState([]);
	const [cities, setCities] = useState([]);
	const dispatch = useDispatch();

	const { showError } = useAlert();

	// Helpers
	const fetchCountries = useCallback(async () => {
		await dispatch(getCountryList())
			.unwrap()
			.then((response) => {
				setCountries(response?.map((item) => item?.shortCode));
			})
			.catch((error) => {
				AppLogger.error(error);
				showError({
					title: 'Error',
					message: 'Something went wrong while fetching countries data.'
				});
				setCountries([]);
			});
	}, []);

	const fetchCitiesByCountry = useCallback(async (countryName) => {
		if (!countryName) {
			setCities([]);
			return;
		}

		return await dispatch(getCityByCountry(countryName))
			.unwrap()
			.then((response) => {
				setCities(response?.data?.map((item) => item?.name));
				return response?.data?.map((item) => item?.name);
			})
			.catch((error) => {
				AppLogger.error(error);
				showError({
					title: 'Error',
					message: 'Something went wrong while fetching cities data.'
				});
				setCities([]);
				return [];
			});
	}, []);

	// Effects
	useEffect(() => {
		fetchCountries();
	}, []);

	// Returned variables and methods
	return {
		countries,
		cities,
		fetchCitiesByCountry
	};
};

export default useAddressData;
